import { ExportTemplatePresetValue } from '@aibees/elephant/components/export-dialog';
import { useTableActionContext } from '@aibees/elephant/context';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { ElephantPresetType, SearchTable } from '@aibees/elephant/types';
import {
  useBrowsePresetApi,
  useCreatePresetMutationApi,
} from '@aibees/shared/api';
import { PresetVisibility } from '@aibees/shared/definition';
import { useEffect } from 'react';
import { useDefaultConvertTemplateData } from './use-default-convert-template-data';

export function useCreateDefaultExportTemplate() {
  const type = useSearchTypeFromRoute();
  const defaultTemplateData = useDefaultConvertTemplateData();
  const { integrationConfig } = useTableActionContext();
  const api = useCreatePresetMutationApi<ExportTemplatePresetValue>(
    false,
    true
  );

  const presetTypeMap: Record<SearchTable, ElephantPresetType> = {
    [SearchTable.Company]:
      ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.People]:
      ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.Employees]:
      ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
    [SearchTable.BuyingTeam]: ElephantPresetType.BUYING_TEAM_MATRIX,
  };

  const defaultPresetType =
    ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS;
  const presetType = integrationConfig
    ? ElephantPresetType.INTEGRATION_EXPORT_SETTINGS_COLUMNS
    : type
    ? presetTypeMap[type]
    : defaultPresetType;

  const browseApi = useBrowsePresetApi<ExportTemplatePresetValue>({
    type: presetType,
    name: 'Default Export Template',
  });

  useEffect(() => {
    const isDefaultTemplateMissing = browseApi.data?.empty;
    // TODO use it after the backend is ready

    if (isDefaultTemplateMissing && api.isIdle && defaultTemplateData) {
      api.mutateAsync({
        type: presetType,
        name: 'Default Export Template',
        value: {
          default: true,
          items: defaultTemplateData as any,
        } as any,
        allowDuplication: false,
        visibility: PresetVisibility.PRIVATE,
      });
    }
  }, [browseApi, api.isIdle, presetType, defaultTemplateData, api]);
}
